var map = {
	"./binocular.svg": 1070,
	"./bullit.svg": 1071,
	"./crown.svg": 1072,
	"./crown2.svg": 1073,
	"./earth.svg": 1074,
	"./fire.svg": 1075,
	"./globe.svg": 1076,
	"./group.svg": 1077,
	"./heart.svg": 1078,
	"./hourglass.svg": 1079,
	"./medal.svg": 1080,
	"./sad.svg": 1081,
	"./smile.svg": 1082,
	"./target.svg": 1083,
	"./thunder-move.svg": 1084,
	"./thunder.svg": 1085,
	"./timer.svg": 1086,
	"./trophy-1.svg": 1087,
	"./trophy.svg": 1088,
	"./visible.svg": 1089
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 506;